import * as Yup from 'yup';
import ShopGroup from "../entities/shop-group.entity";


export type ShopGroupForm = ShopGroup;

export type ShopGroupFormShape = {
  [key in keyof ShopGroupForm]?: any;
}

export const schema = Yup.object().shape<ShopGroupFormShape>({
  label: Yup.string().required('Digite um nome para o grupo de lojas').min(3, 'O nome deve conter no mínimo 3 caracteres')
});
